var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigSuccessfulCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.161,
    height: 128.161,
    viewBox: "0 0 128.161 128.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .greenBigCheckCircle {\n                fill: #d2f7ec;\n                stroke-width: 2px;\n            }\n\n            .greenBigCheckCircle,\n            .greenBigCheck {\n                stroke: #0dce93;\n            }\n\n            .greenBigCheck,\n            .greenBigCheckCircleOut1 {\n                fill: none;\n            }\n\n            .greenBigCheck {\n                stroke-width: 3px;\n            }\n\n            .greenBigCheckCircleOut2 {\n                stroke: none;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-857 -1222.865)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(857 1222.865)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "greenBigCheckCircle",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "greenBigCheckCircleOut2",
    cx: 64.081,
    cy: 64.081,
    r: 64.081
  }), /*#__PURE__*/React.createElement("circle", {
    className: "greenBigCheckCircleOut1",
    cx: 64.081,
    cy: 64.081,
    r: 63.081
  }))), /*#__PURE__*/React.createElement("path", {
    className: "greenBigCheck",
    d: "M-10877.523-709.641l25.818,25.813,41.092-41.1",
    transform: "translate(11765.116 1994.447)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSuccessfulCheckmark);
export default __webpack_public_path__ + "static/media/big-successful-checkmark.db55ac08.svg";
export { ForwardRef as ReactComponent };